/* Asset: djuce-cart-api.js */

/* Asset: djuce-cart-api.js */

class DjuceCartAPI {
  constructor() {
    this.drawerId = 'djuce-cart-sidebar';
    this.sectionId = 'djuce-cart-drawer';
    this.drawerElement = document.getElementById(this.drawerId);

    this.quantityDebounceTimer = null;

    if (!this.drawerElement) {
      console.warn('Djuce Cart: Drawer HTML not found in the DOM.');
      return;
    }

    this.bindEvents();
  }

  bindEvents() {
    // 1. Intercept 'Add to Cart' forms
    document.addEventListener('submit', (evt) => {
      const form = evt.target;
      const action = form.getAttribute('action') || '';

      if (action.includes('/cart/add')) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.handleAddToCart(form);
      }
    }, true);

    // 2. Global Event Delegation
    document.addEventListener('click', (evt) => {

      // A. Remove Item
      const removeLink = evt.target.closest('.remove-item');
      if (removeLink) {
        evt.preventDefault();
        this.changeItemQuantity(removeLink.getAttribute('data-key'), 0);
        return;
      }

      // B. +/- Quantity Buttons
      const qtyBtn = evt.target.closest('.djuce-qty-btn');
      if (qtyBtn) {
        evt.preventDefault();
        const key = qtyBtn.getAttribute('data-key');
        const newQty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        
        // Route to our new debounced handler instead of changeItemQuantity
        this.handleQuantityClick(key, newQty, qtyBtn); 
        return;
      }
     
      // C. Open Cart links
      // Opening cart handled in layout/theme.liquid <head>

      // D. Delegated Close/Continue Shopping Buttons
      const closeBtn = evt.target.closest('[data-js-close]');
      if (closeBtn && closeBtn.closest(`#${this.drawerId}`)) {
        evt.preventDefault();
        this.closeDrawer();
      }
    });
  }

  handleQuantityClick(key, newQty, btn) {
    
    if (newQty < 0) return;

    const actionContainer = btn.closest('.djuce-cart-item-actions');

    if (actionContainer) {
      const display = actionContainer.querySelector('.djuce-qty-display');
      const minusBtn = actionContainer.querySelector('.djuce-qty-btn[aria-label="Decrease quantity"]');
      const plusBtn = actionContainer.querySelector('.djuce-qty-btn[aria-label="Increase quantity"]');

      // Update the visual number
      if (display) display.textContent = newQty;

      // Update the data attributes so the next click calculates correctly
      //if (minusBtn) minusBtn.setAttribute('data-qty', newQty - 1);
      if (minusBtn) minusBtn.setAttribute('data-qty', Math.max(0, newQty - 1));
      if (plusBtn) plusBtn.setAttribute('data-qty', newQty + 1);
    }

    // 2. Clear any existing timer (this is the "debounce" action)
    clearTimeout(this.quantityDebounceTimer);

    // Optional: Add a subtle loading class that DOES NOT use pointer-events:none
    // this.drawerElement.classList.add('is-syncing-silently');

    // 3. Set a new timer. 400ms is the sweet spot for human rapid-clicking.
    this.quantityDebounceTimer = setTimeout(() => {
      // If the user drops quantity to 0, or we finalized the number, run the actual API call
      this.changeItemQuantity(key, newQty);
    }, 400);
  }

  openDrawer() {
    if (this.drawerElement && typeof this.drawerElement.show === 'function') {
      this.drawerElement.show();
    }
  }

  closeDrawer() {
    if (this.drawerElement && typeof this.drawerElement.hide === 'function') {
      this.drawerElement.hide();
    }
  }

  setLoading(isLoading) {
    if (this.drawerElement) {
      this.drawerElement.classList.toggle('is-loading', isLoading);
      const inner = document.getElementById('DjuceCartDrawer-Inner');
      if (inner) inner.setAttribute('aria-busy', isLoading.toString());
    }
    if (isLoading) this.showError('');
  }

  showError(message) {
    const errorEl = document.getElementById('DjuceCart-Error');

    if (!message) {
      if (errorEl) { errorEl.textContent = ''; errorEl.style.display = 'none'; }
      return;
    }

    let displayMessage = message;
    if (message.toLowerCase().includes('fetch') ||
      message.toLowerCase().includes('network') ||
      message.toLowerCase().includes('failed')) {
      displayMessage = 'Something went wrong. Please try again.';
    }

    if (errorEl) {
      errorEl.textContent = displayMessage;
      errorEl.style.display = 'block';
    } else {
      alert(displayMessage);
    }
  }

  // ---  Reusable HTML Injector ---
  updateCartHTML(htmlString) {
    // 1. Capture State BEFORE destruction
    const currentInner = document.getElementById('DjuceCartDrawer-Inner');
    const currentScroll = currentInner ? currentInner.scrollTop : 0;
    
    // Capture the exact button the user is currently focused on
    const activeEl = document.activeElement;
    let focusSelector = null;
    
    if (activeEl && this.drawerElement.contains(activeEl)) {
      if (activeEl.hasAttribute('data-key') && activeEl.classList.contains('djuce-qty-btn')) {
        // e.g., button[data-key="12345"][aria-label="Increase quantity"]
        focusSelector = `${activeEl.tagName.toLowerCase()}[data-key="${activeEl.getAttribute('data-key')}"][aria-label="${activeEl.getAttribute('aria-label')}"]`;
      } else if (activeEl.id) {
        focusSelector = `#${activeEl.id}`;
      }
    }

    // 2. Parse the new DOM
    const html = new DOMParser().parseFromString(htmlString, 'text/html');

    // Handle Error States
    const newErrorEl = html.getElementById('DjuceCart-Error');
    const currentErrorEl = document.getElementById('DjuceCart-Error');
    if (newErrorEl && currentErrorEl && currentErrorEl.style.display === 'block') {
       newErrorEl.textContent = currentErrorEl.textContent;
       newErrorEl.style.display = 'block';
    }

    // 3. Execute the Destructive Update
    const newInner = html.getElementById('DjuceCartDrawer-Inner');
    if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;

    const newFooter = html.querySelector('.sidebar__footer');
    const currentFooter = this.drawerElement.querySelector('.sidebar__footer');
    if(newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;


    // 4. Update Header Item Count (Singular/Plural)
    const newHeaderCount = html.querySelector('[data-djuce-drawer-count]');
    const currentHeaderCount = this.drawerElement.querySelector('[data-djuce-drawer-count]');

    if (newHeaderCount && currentHeaderCount) {
      currentHeaderCount.innerHTML = newHeaderCount.innerHTML;
    }

    // Handle Empty State Class
    const newDrawerElement = html.getElementById(this.drawerId);
    if (newDrawerElement) {
      if (newDrawerElement.classList.contains('cart-is-empty')) {
          this.drawerElement.classList.add('cart-is-empty');
      } else {
          this.drawerElement.classList.remove('cart-is-empty');
      }
    }

    // 4. Restore State AFTER destruction
    if (currentInner) {
      currentInner.scrollTop = currentScroll; // Prevents scroll jumping
    }

    if (focusSelector) {
      const elToFocus = this.drawerElement.querySelector(focusSelector);
      if (elToFocus) elToFocus.focus(); // Prevents a11y focus loss
    }
  }

  // ------------------------------------

  async handleAddToCart(form) {
    this.openDrawer();
    this.setLoading(true);

    try {
      const formData = new FormData(form);

      formData.append('sections', this.sectionId);

      let actionUrl = form.getAttribute('action').split('?')[0];
      if (!actionUrl.endsWith('.js')) actionUrl += '.js';

      const addResponse = await fetch(actionUrl, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      const parsedAdd = await addResponse.json();

      if (!addResponse.ok) throw new Error(parsedAdd.description || 'Add to cart failed. Please try again.');

      // Fetch the FULL updated cart state
      const rootUrl = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(`${rootUrl}cart.js`);
      if (!cartResponse.ok) throw new Error('Failed to synchronize cart state. Please refresh the page.');

      const fullCart = await cartResponse.json();

      // Update HTML via the bundled response (Zero extra network latency!)
      if (parsedAdd.sections && parsedAdd.sections[this.sectionId]) {
        this.updateCartHTML(parsedAdd.sections[this.sectionId]);
      }

      this.broadcastUpdate(fullCart);

    } catch (error) {
      console.error('Cart API Add Error:', error);
      this.showError(error.message);
    } finally {
      this.setLoading(false);
    }
  }

  async changeItemQuantity(key, quantity) {
    this.setLoading(true);

    try {
      const body = JSON.stringify({
        id: key,
        quantity: quantity,
        sections: this.sectionId
      });

      const cartChangeUrl = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/change.js` : '/cart/change.js';

      const changeResponse = await fetch(cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      });

      const parsedCart = await changeResponse.json();

      if (!changeResponse.ok) throw new Error(parsedCart.description || 'Failed to change quantity.');

      // /cart/change.js returns FULL cart state + sections! (1 Single Request)
      if (parsedCart.sections && parsedCart.sections[this.sectionId]) {
        this.updateCartHTML(parsedCart.sections[this.sectionId]);
      }

      this.broadcastUpdate(parsedCart);

    } catch (error) {
       console.error('DjuceCartAPI Quantity Error:', error);
       this.showError(error.message);
    } finally {
      this.setLoading(false);
    }
  }

  broadcastUpdate(cartObject) {
    window.dispatchEvent(new CustomEvent('djuce:cart:updated', { detail: cartObject }));
  }
}

window.djuceCartAPI = new DjuceCartAPI();

